export const removeExtension = (fileName: string): string => fileName.replace(/\.[^/.]+$/, '');
